export default "__VITE_ASSET__CCWB3Trd__"